/**
 * Canvas palette.
 *
 * Canvas cannot read CSS custom properties without a getComputedStyle call,
 * which forces style resolution — unacceptable inside a 60fps draw loop. These
 * constants mirror the tokens in global.css exactly; change one, change both.
 */

export const C = {
  bg0: '#121212',
  bg1: '#121212',
  bg2: '#1f1f1f',
  bg3: '#292929',

  grid: 'rgba(255,255,255,0.035)',
  gridStrong: 'rgba(255,255,255,0.07)',
  axis: '#28323f',
  line: '#1a2029',

  text0: '#eef1ef',
  text1: '#abb6b5',
  text2: '#879391',
  text3: '#6e7d79',

  up: '#2ebd85',
  upBright: '#43e3a3',
  upFill: 'rgba(46,189,133,0.22)',
  upWash: 'rgba(46,189,133,0.10)',
  upWick: '#26a173',

  down: '#f6465d',
  downBright: '#ff6b7d',
  downFill: 'rgba(246,70,93,0.22)',
  downWash: 'rgba(246,70,93,0.10)',
  downWick: '#d33a4f',

  accent: '#d6d6d6',
  accentDim: 'rgba(184,213,194,0.18)',
  info: '#4c8dff',
  infoDim: 'rgba(76,141,255,0.18)',
  violet: '#a78bfa',
  neutral: '#6b7889',

  crosshair: 'rgba(180,196,214,0.42)',
  crosshairLabel: '#1d2531',

  /** Ordered palette for indicator lines, cycled as the user adds them. */
  series: [
    '#f0b429',
    '#4c8dff',
    '#a78bfa',
    '#f472b6',
    '#22d3ee',
    '#fb923c',
    '#84cc16',
    '#e879f9',
  ] as string[],
} as const;

/** Canvas font strings. Keep the stack identical to --mono in global.css. */
const STACK = `'JetBrains Mono','IBM Plex Mono',ui-monospace,SFMono-Regular,Menlo,Consolas,monospace`;

export const F = {
  micro: `9.5px ${STACK}`,
  xs: `10.5px ${STACK}`,
  sm: `11.5px ${STACK}`,
  md: `12.5px ${STACK}`,
  smBold: `600 11.5px ${STACK}`,
  xsBold: `600 10.5px ${STACK}`,
  lgBold: `600 15px ${STACK}`,
} as const;

/** Colour for a value relative to a reference, with a neutral middle. */
export function dirColor(value: number, reference: number): string {
  if (!Number.isFinite(value) || !Number.isFinite(reference)) return C.text1;
  if (value > reference) return C.up;
  if (value < reference) return C.down;
  return C.text1;
}

